const STORAGE_KEY = 'yomou_wordlist';

export function loadWordList() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

export function saveWordList(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

export function addWord(list, token, entry, sentence = '') {
  const word = token.surface_form;
  if (list.some(w => w.word === word)) return list;

  const reading = token.reading || entry?.japanese?.[0]?.reading || '';
  const definitions = entry?.senses?.slice(0, 5).map(s => s.english_definitions?.join(', ')).filter(Boolean) || [];
  const pos = entry?.senses?.[0]?.parts_of_speech?.[0] || '';
  const jlpt = entry?.jlpt?.[0]?.replace('jlpt-', '').toUpperCase() || '';

  return [...list, { word, reading, pos, definitions, jlpt, sentence, savedAt: new Date().toISOString() }];
}

export function removeWord(list, word) {
  return list.filter(w => w.word !== word);
}

export function exportCSV(list) {
  const header = ['Word', 'Reading', 'Part of Speech', 'JLPT', 'Definitions', 'Sentence', 'Saved At'];
  const rows = list.map(w => [
    w.word,
    w.reading,
    w.pos,
    w.jlpt || '',
    w.definitions.join(' / '),
    w.sentence || '',
    w.savedAt.slice(0, 10),
  ]);
  const csv = [header, ...rows]
    .map(r => r.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    .join('\n');
  downloadFile(csv, 'yomou_wordlist.csv', 'text/csv;charset=utf-8;');
}

export function exportAnki(list) {
  const rows = list.map(w => {
    const front = w.reading ? `${w.word}[${w.reading}]` : w.word;
    const back = [
      w.definitions.join('<br>'),
      w.pos ? `<i>${w.pos}</i>` : '',
      w.sentence ? `<br><hr><small>${w.sentence}</small>` : '',
    ].filter(Boolean).join('<br><br>');
    return `${front}\t${back}`;
  });
  downloadFile(rows.join('\n'), 'yomou_anki.txt', 'text/plain;charset=utf-8;');
}

function downloadFile(content, filename, mime) {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
